<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?'新增商品档案':'修改商品档案'}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="100px">
            <el-form-item :label="$t('logo_img')" prop="img_lnk">
                <myCropImg :autoCropWidthHeight="[600, 600]" crop_height="700px" :original_url="formData.img_lnk" @cropImgUpload="setImgLnk"></myCropImg>
            </el-form-item>
            <el-form-item :label="$t('cat')" prop="cat_select">
                <el-cascader class="fillw" :filterable="true" v-model="formData.cat_select" :placeholder="$t('select')"
                             :options="cats" @change="onCatChange"></el-cascader>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cname')" prop="goods_cname">
                        <el-input v-model="formData.goods_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="商品编码" prop="goods_code">
                        <el-input v-model="formData.goods_code" placeholder="非必填"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="面值" prop="new_price">
                        <el-input v-model="formData.new_price" :placeholder="$t('input')">
                            <span slot="append">{{$t('price_unit')}}</span>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('sort')" prop="sort_id">
                        <el-input v-model="formData.sort_id" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item :label="$t('status')" prop="goods_status">
                <el-radio-group v-model="formData.goods_status">
                    <el-radio v-for="item in goods_status" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                </el-radio-group>
                <span class="f-orange" v-if="op == 'upd'">（注：下架只会影响后续不可使用，不会影响已使用到的数据）</span>
            </el-form-item>
            <el-row v-if="op == 'upd'">
                <el-col :span="12"><el-form-item :label="$t('add_user')"><el-input v-model="formData.add_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('add_time')"><el-input v-model="formData.add_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-row v-if="op == 'upd'">
                <el-col :span="12"><el-form-item :label="$t('upd_user')"><el-input v-model="formData.upd_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('upd_time')"><el-input v-model="formData.upd_time" disabled></el-input></el-form-item></el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    import myCropImg from "../../../components/myCropImg"
    export default {
        components:{
            myCropImg
        },
        data:function(){
            return{
                relist:false,
                op: this.$base.getRequest().op,
                formData: {
                    goods_id:'',
                    sort_id:'99',
                    cat_id : '',
                    cat_id2 : '',
                    cat_select: [],
                    goods_code : '',
                    goods_cname : '',
                    new_price : '',
                    img_lnk : '',
                    goods_status:'0',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    goods_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    new_price: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cat_select: [{required: true, message: this.$t('select'), trigger: 'change', type:'array'}],
                    goods_status: [{required: true, message: this.$t('select'), trigger: 'change'}],
                },
                cats:[],
                goods_status:[]
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.goods_id = this.$base.getRequest().id;
            if(this.op == 'upd'){
                this.getInfo();
            }
            else{
                this.getLoad();
            }
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            setImgLnk (file_path) {
                this.formData.img_lnk = file_path
            },
            onCatChange: function (value) {
                this.formData.cat_id = value[0];
                this.formData.cat_id2 = value[1];
            },
            getLoad: function(){
                this.$base.showLoading();
                this.$request.sendPost("product-code/before-add",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                        this.goods_status = data.goods_status;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getInfo: function(){
                var id = this.formData.goods_id;
                if(!id){
                    return;
                }
                var data = {
                    goods_id: id
                };
                this.$base.showLoading();
                this.$request.sendPost("product-code/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.formData.cat_select = [this.formData.cat_id, this.formData.cat_id2];
                        this.cats = data.cats;
                        this.goods_status = data.goods_status;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = this.op == 'upd' ? "product-code/upd" : "product-code/add";
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/code/save.vue